export const userConstants = {
  REQUEST_SUCCESS: "USERS_AUTH_REQUEST",
  REQUEST_FAILURE: "USERS_AUTH_FAILURE",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  LOGOUT: "USERS_LOGOUT",
  GET_ALL_PRODUCTS_FAILURE: "GET_ALL_PRODUCTS_FAILURE",
  GET_ALL_PRODUCTS_SUCCESS: "GET_ALL_PRODUCTS_SUCCESS",
  GET_A_PRODUCT_SUCCESS: "GET_A_PRODUCT_SUCCESS",
  GET_A_PRODUCT_FAILURE: "GET_A_PRODUCT_FAILURE",
  GET_PRODUCT_DESCRIPTION: "GET_PRODUCT_DESCRIPTION",
  GET_CART_ITEMS: "GET_CART_ITEMS",
  GET_ORDER_ITEMS: "GET_ORDER_ITEMS",
  GET_SELLER_ORDERS: "GET_SELLER_ORDERS",
  FILTER_SELLER_ORDERS: "FILTER_SELLER_ORDERS",
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  SET_ADDRESS: "SET_ADDRESS",
  GET_ADDRESS: "GET_ADDRESS",
  SET_DEFAULT_ADDRESS: "SET_DEFAULT_ADDRESS",
  ADDRESS_DELETED: "ADDRESS_DELETED",
  CHECKOUT_RESPONSE: "CHECKOUT_RESPONSE",
  EDIT_USER_PROFILE: "EDIT_USER_PROFILE",
  GET_PRODUCT_DATA: "GET_PRODUCT_DATA",
  GET_USER_PROFILE: "GET_USER_PROFILE",
  SEARCH_QUERY_PARAMS: "SEARCH_QUERY_PARAMS",
  NEW_ARRIVAL_PRODUCTS: "NEW_ARRIVAL_PRODUCTS",
  GET_SELLER_DASHBOARD_ITEM: "GET_SELLER_DASHBOARD_ITEM",
  PRODUCTS_LISTING: "PRODUCTS_LISTING",
  LIST_OF_MY_CHATS: "LIST_OF_MY_CHATS",
  GET_MY_MESSAGE: "GET_MY_MESSAGE",
  SEND_MY_MESSAGE: "SEND_MY_MESSAGE",
  CLEAR_MY_MESSAGE: "CLEAR_MY_MESSAGE",
  GET_SELLER_MARKET_CAMPAIGN: "GET_SELLER_MARKET_CAMPAIGN",
  GET_WISHLISTS: "GET_WISHLISTS",
  ADD_WISHLIST: "ADD_WISHLIST",
  REMOVE_WISHLIST: "REMOVE_WISHLIST",
  STAR_RATING: "STAR_RATING",
  TRACK_ORDER: "TRACK_ORDER",
  GET_RATED_PRODUCT: "GET_RATED_PRODUCT",
  GET_BUYER_TRANSACTIONS: "GET_BUYER_TRANSACTIONS",
  GET_RECENTLY_VIEWED_PRODUCT: "GET_RECENTLY_VIEWED_PRODUCT",
  GET_USER_INBOX: "GET_USER_INBOX",
  VERIFY: "VERIFY",
  GET_CATEGORY: "GET_CATEGORY",
  GET_CATEGORY_DETAIL: "GET_CATEGORY_DETAIL",
  GET_PRODUCT: "GET_PRODUCT",
  GET_ALL_JOBS: "GET_ALL_JOBS",
  GET_JOB_POSTINGS: "GET_JOB_POSTINGS",
  GET_JOB_POSTING_DETAIL: "GET_JOB_POSTING_DETAIL",
  SUBMIT_JOB_APPLICATION: "SUBMIT_JOB_APPLICATION",
  GET_ALL_USERS: "GET_ALL_USERS",
  GET_NDA: "GET_NDA",
  GET_NDA_PRICE_LIST: "GET_NDA_PRICE_LIST",
  GET_NDA_PACKAGES_LIST:"GET_NDA_PACKAGES_LIST",
  GET_MY_NDAPROPOSAL: "GET_MY_NDAPROPOSAL",
  GET_PURCHASED_NDA: "GET_PURCHASED_NDA",
  GET_ADVERT: "GET_ADVERT",
  CONVERT_CURRENCY: "CONVERT_CURRENCY",
  ADD_SPONSORSHIP_PRODUCT: "ADD_SPONSORSHIP_PRODUCT",
  GET_ALL_SPONSORSHIP_PRODUCT_SUCCESS: "GET_ALL_SPONSORSHIP_PRODUCT_SUCCESS",
  GET_ALL_SPONSORSHIP_PRODUCTS_FAILURE: "GET_ALL_SPONSORSHIP_PRODUCTS_FAILURE",
  GET_A_SPONSORSHIP_PRODUCT_SUCCESS: "GET_A_SPONSORSHIP_PRODUCT_SUCCESS",
  GET_A_SPONSORSHIP_PRODUCT_FAILURE: "GET_A_SPONSORSHIP_PRODUCT_FAILURE",
  REMOVEDATA:"REMOVEDATA",
  GET_SELLER_VERIFICATION: "GET_SELLER_VERIFICATION",
  SUBMIT_SELLER_VERIFICATION: "SUBMIT_SELLER_VERIFICATION",
  GET_FILTER_OPTIONS: "GET_FILTER_OPTIONS",
  GET_CAMPAIGN_UPDATES: "GET_CAMPAIGN_UPDATES",
  CREATE_CAMPAIGN_UPDATE: "CREATE_CAMPAIGN_UPDATE",
  GET_SPONSORSHIP_PRODUCT_DETAIL: "GET_SPONSORSHIP_PRODUCT_DETAIL",
  GET_CAMPAIGN_REWARDS: "GET_CAMPAIGN_REWARDS",
  GET_SELLER_BOOST_STATUS: "GET_SELLER_BOOST_STATUS",
  BOOST_PRODUCT_SUCCESS: "BOOST_PRODUCT_SUCCESS",
  GET_BUYER_DASHBOARD_STATS: "GET_BUYER_DASHBOARD_STATS",
  GET_BUYER_DASHBOARD_STATS_FAILURE: "GET_BUYER_DASHBOARD_STATS_FAILURE",
  GET_SELLER_DASHBOARD_STATS: "GET_SELLER_DASHBOARD_STATS",
  GET_SELLER_PRODUCT_VIEWS: "GET_SELLER_PRODUCT_VIEWS",
  GET_SELLER_PRODUCT_VIEWS_FAILURE: "GET_SELLER_PRODUCT_VIEWS_FAILURE",
  GET_BOOST_ANALYTICS: "GET_BOOST_ANALYTICS",
  GET_SELLER_PERFORMANCE: "GET_SELLER_PERFORMANCE",
  GET_REVENUE_SHARE_OFFER: "GET_REVENUE_SHARE_OFFER",
  CREATE_REVENUE_SHARE_OFFER: "CREATE_REVENUE_SHARE_OFFER",
  UPDATE_REVENUE_SHARE_OFFER: "UPDATE_REVENUE_SHARE_OFFER",
  SET_DETECTED_COUNTRY: "SET_DETECTED_COUNTRY",
  SAVE_DETECTED_COUNTRY_TO_PROFILE: "SAVE_DETECTED_COUNTRY_TO_PROFILE",
  GET_BUYER_QUOTES: "GET_BUYER_QUOTES",
  GET_SELLER_QUOTES: "GET_SELLER_QUOTES",
  SUBMIT_QUOTE_REQUEST: "SUBMIT_QUOTE_REQUEST",
  RESPOND_TO_QUOTE: "RESPOND_TO_QUOTE",
  COUPON_APPLIED: "COUPON_APPLIED",
  COUPON_REMOVED: "COUPON_REMOVED",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  GET_FEATURED_SELLERS: "GET_FEATURED_SELLERS",
  GET_PRODUCT_QUESTIONS: "GET_PRODUCT_QUESTIONS",
  GET_SELLER_VACATION: "GET_SELLER_VACATION",
  UPDATE_SELLER_VACATION: "UPDATE_SELLER_VACATION",
  GET_CAMPAIGN_RATING: "GET_CAMPAIGN_RATING",
  GET_CAMPAIGN_EXTENSION_STATUS: "GET_CAMPAIGN_EXTENSION_STATUS",
  REQUEST_CAMPAIGN_EXTENSION: "REQUEST_CAMPAIGN_EXTENSION",
  GET_SELLER_BUNDLES: "GET_SELLER_BUNDLES",
  CREATE_SELLER_BUNDLE: "CREATE_SELLER_BUNDLE",
  DELETE_SELLER_BUNDLE: "DELETE_SELLER_BUNDLE",
  GET_SELLER_COLLECTIONS: "GET_SELLER_COLLECTIONS",
  CREATE_SELLER_COLLECTION: "CREATE_SELLER_COLLECTION",
  DELETE_SELLER_COLLECTION: "DELETE_SELLER_COLLECTION",
  GET_WISHLIST_SHARE_STATUS: "GET_WISHLIST_SHARE_STATUS",
  TOGGLE_WISHLIST_SHARE: "TOGGLE_WISHLIST_SHARE",
  GET_SHARED_WISHLIST: "GET_SHARED_WISHLIST",
  GET_PRICE_HISTORY: "GET_PRICE_HISTORY",
  GET_SAVED_SEARCHES: "GET_SAVED_SEARCHES",
  SAVE_SEARCH: "SAVE_SEARCH",
  DELETE_SAVED_SEARCH: "DELETE_SAVED_SEARCH",
  TOGGLE_SAVED_SEARCH_NOTIFY: "TOGGLE_SAVED_SEARCH_NOTIFY",
  JOIN_WAITLIST: "JOIN_WAITLIST",
  LEAVE_WAITLIST: "LEAVE_WAITLIST",
  GET_WAITLIST_STATUS: "GET_WAITLIST_STATUS",
  GET_USER_WAITLIST: "GET_USER_WAITLIST",
  GET_SELLER_WAITLIST_DEMAND: "GET_SELLER_WAITLIST_DEMAND",
  WAITLIST_DEPOSIT: "WAITLIST_DEPOSIT",
  GET_EXCLUSIVE_WINDOW: "GET_EXCLUSIVE_WINDOW",
  GET_BUYER_LOYALTY: "GET_BUYER_LOYALTY",
  GET_SELLER_GOALS: "GET_SELLER_GOALS",
  UPDATE_SELLER_GOALS: "UPDATE_SELLER_GOALS",
  GET_SELLER_DISPUTES: "GET_SELLER_DISPUTES",
  RESPOND_TO_DISPUTE: "RESPOND_TO_DISPUTE",

  // Buyer Disputes
  GET_BUYER_DISPUTES: "GET_BUYER_DISPUTES",
  CREATE_BUYER_DISPUTE: "CREATE_BUYER_DISPUTE",
  GET_DISPUTE_DETAIL: "GET_DISPUTE_DETAIL",
  UPLOAD_DISPUTE_EVIDENCE: "UPLOAD_DISPUTE_EVIDENCE",
  APPEAL_DISPUTE: "APPEAL_DISPUTE",

  // Arbitration
  REQUEST_ARBITRATION: "REQUEST_ARBITRATION",
  GET_ARBITRATION_STATUS: "GET_ARBITRATION_STATUS",
  PAY_ARBITRATION_BOND: "PAY_ARBITRATION_BOND",
  CONFIRM_ARBITRATION_BOND: "CONFIRM_ARBITRATION_BOND",

  GET_PRODUCT_CERTIFICATIONS: "GET_PRODUCT_CERTIFICATIONS",
  UPLOAD_PRODUCT_CERTIFICATION: "UPLOAD_PRODUCT_CERTIFICATION",

  // Shipping Estimates
  GET_SHIPPING_ESTIMATE: "GET_SHIPPING_ESTIMATE",
  CLEAR_SHIPPING_ESTIMATE: "CLEAR_SHIPPING_ESTIMATE",
  GET_ADMIN_SHIPPING_RATES: "GET_ADMIN_SHIPPING_RATES",
  CREATE_SHIPPING_RATE: "CREATE_SHIPPING_RATE",
  UPDATE_SHIPPING_RATE: "UPDATE_SHIPPING_RATE",
  DELETE_SHIPPING_RATE: "DELETE_SHIPPING_RATE",

  // Return / Refund Requests
  GET_BUYER_RETURNS: "GET_BUYER_RETURNS",
  CREATE_RETURN_REQUEST: "CREATE_RETURN_REQUEST",
  GET_SELLER_RETURNS: "GET_SELLER_RETURNS",
  RESPOND_TO_RETURN: "RESPOND_TO_RETURN",
  CONFIRM_RETURN_RECEIPT: "CONFIRM_RETURN_RECEIPT",
  UPLOAD_RETURN_EVIDENCE: "UPLOAD_RETURN_EVIDENCE",

  // Two-Factor Authentication
  TFA_REQUIRED: "TFA_REQUIRED",
  TFA_SETUP_SUCCESS: "TFA_SETUP_SUCCESS",
  TFA_ENABLED: "TFA_ENABLED",
  TFA_DISABLED: "TFA_DISABLED",
  TFA_VERIFY_SUCCESS: "TFA_VERIFY_SUCCESS",
  TFA_BACKUP_CODES: "TFA_BACKUP_CODES",

  // Price Alerts
  GET_PRICE_ALERTS: "GET_PRICE_ALERTS",
  SET_PRICE_ALERT: "SET_PRICE_ALERT",
  REMOVE_PRICE_ALERT: "REMOVE_PRICE_ALERT",
  GET_PRICE_ALERT_STATUS: "GET_PRICE_ALERT_STATUS",

  // Product Subscriptions (Recurring Orders)
  GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",
  CREATE_SUBSCRIPTION: "CREATE_SUBSCRIPTION",
  UPDATE_SUBSCRIPTION: "UPDATE_SUBSCRIPTION",
  CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",

  // Landing Page Redesign
  GET_HOMEPAGE_AD: "GET_HOMEPAGE_AD",
  GET_BEST_SELLERS: "GET_BEST_SELLERS",
  GET_RECOMMENDED_PRODUCTS: "GET_RECOMMENDED_PRODUCTS",
  GET_ACTIVE_CAMPAIGNS: "GET_ACTIVE_CAMPAIGNS",
  GET_SUCCESS_STORIES: "GET_SUCCESS_STORIES",

  // Order Tracking
  GET_ORDER_TRACKING: "GET_ORDER_TRACKING",
  UPDATE_ORDER_TRACKING: "UPDATE_ORDER_TRACKING",
  CONFIRM_DELIVERY: "CONFIRM_DELIVERY",

  // RFQ (Request for Quote) System
  GET_BUYER_RFQS: "GET_BUYER_RFQS",
  CREATE_RFQ: "CREATE_RFQ",
  GET_RFQ_DETAIL: "GET_RFQ_DETAIL",
  GET_RFQ_QUOTES: "GET_RFQ_QUOTES",
  GET_MANUFACTURER_RFQS: "GET_MANUFACTURER_RFQS",
  SUBMIT_RFQ_QUOTE: "SUBMIT_RFQ_QUOTE",
  ACCEPT_RFQ_QUOTE: "ACCEPT_RFQ_QUOTE",
  REJECT_RFQ_QUOTE: "REJECT_RFQ_QUOTE",
  SIGN_RFQ_NDA: "SIGN_RFQ_NDA",
  GET_RFQ_PRICE_SUGGESTION: "GET_RFQ_PRICE_SUGGESTION",

  // Seller Analytics
  GET_SELLER_ANALYTICS: "GET_SELLER_ANALYTICS",

  // Product Bundling & Upsell
  GET_FEATURED_BUNDLES: "GET_FEATURED_BUNDLES",
  GET_FREQUENTLY_BOUGHT_TOGETHER: "GET_FREQUENTLY_BOUGHT_TOGETHER",
  GET_RELATED_PRODUCTS_SELLER: "GET_RELATED_PRODUCTS_SELLER",
  UPDATE_SELLER_BUNDLE: "UPDATE_SELLER_BUNDLE",
  SHOW_UPSELL_POPUP: "SHOW_UPSELL_POPUP",
  HIDE_UPSELL_POPUP: "HIDE_UPSELL_POPUP",

  // Wishlist Folders
  GET_WISHLIST_FOLDERS: "GET_WISHLIST_FOLDERS",
  CREATE_WISHLIST_FOLDER: "CREATE_WISHLIST_FOLDER",
  UPDATE_WISHLIST_FOLDER: "UPDATE_WISHLIST_FOLDER",
  DELETE_WISHLIST_FOLDER: "DELETE_WISHLIST_FOLDER",
  MOVE_WISHLIST_ITEM: "MOVE_WISHLIST_ITEM",
  BULK_ADD_TO_CART: "BULK_ADD_TO_CART",
  GET_SELLER_WISHLIST_ANALYTICS: "GET_SELLER_WISHLIST_ANALYTICS",

  // Loyalty & Rewards Program
  GET_LOYALTY_TRANSACTIONS: "GET_LOYALTY_TRANSACTIONS",
  LOYALTY_REDEEM: "LOYALTY_REDEEM",
  GET_LOYALTY_DASHBOARD: "GET_LOYALTY_DASHBOARD",

  // Advanced Order Management
  GET_CANCEL_STATUS: "GET_CANCEL_STATUS",
};
